import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import { useState } from "react";
import {
  LuPrinter,
  LuLoaderCircle,
  LuTriangleAlert,
} from "react-icons/lu";

import { downloadPdf } from "../Services/printService";

export default function PrintButton({ type, id, iconOnly = false }) {
  useUiTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const download = async () => {
    if (loading || !id) return;

    setLoading(true);
    setError("");

    try {
      await downloadPdf(type, id);
    } catch (err) {
      console.error("Erreur impression PDF :", err);

      setError(
        err?.message ||
          uiI18n.t("ui.pdf_failed")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inline-flex flex-col items-start gap-2">
      <button
        type="button"
        onClick={download}
        disabled={loading || !id}
        aria-busy={loading}
        aria-label={uiI18n.t("print")}
        title={uiI18n.t("ui.download_the_pdf_to_print")}
        className={iconOnly ? "listing-photo-action" : `
          group
          inline-flex
          h-10
          items-center
          justify-center
          gap-2
          rounded-xl
          border
          border-slate-200
          bg-white
          px-4
          text-sm
          font-semibold
          text-slate-700
          shadow-sm
          transition-all
          duration-200

          hover:border-green-200
          hover:bg-green-50
          hover:text-green-700
          hover:shadow

          focus:outline-none
          focus:ring-2
          focus:ring-green-500/20

          disabled:cursor-not-allowed
          disabled:opacity-60
          disabled:hover:border-slate-200
          disabled:hover:bg-white
          disabled:hover:text-slate-700
          disabled:hover:shadow-sm
        `}
      >
        {loading ? (
          <>
            <LuLoaderCircle
              size={18}
              strokeWidth={2}
              className="animate-spin"
            />

            {!iconOnly && <span>{uiI18n.t("preparing")}</span>}
          </>
        ) : (
          <>
            <LuPrinter
              size={18}
              strokeWidth={2}
              className="
                transition-transform
                duration-200
                group-hover:scale-110
              "
            />

            {!iconOnly && <span>{uiI18n.t("print")}</span>}
          </>
        )}
      </button>

      {error && (
        <div
          role="alert"
          className="
            flex
            max-w-xs
            items-start
            gap-1.5
            text-xs
            font-medium
            text-red-600
          "
        >
          <LuTriangleAlert
            size={14}
            className="mt-0.5 shrink-0"
          />

          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
